module.exports = "/images/milano-17.jpg";